import { render, staticRenderFns } from "./AssignmentDetailItem.vue?vue&type=template&id=3ab6942f&scoped=true&"
import script from "./AssignmentDetailItem.vue?vue&type=script&lang=js&"
export * from "./AssignmentDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentDetailItem.vue?vue&type=style&index=0&id=3ab6942f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab6942f",
  null
  
)

export default component.exports